import { render } from "./toolTips.vue?vue&type=template&id=20374c3e"
import script from "./toolTips.vue?vue&type=script&lang=js"
export * from "./toolTips.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__